import { IBadge } from '../entities/IBadge';
import { BadgeColorEnum } from '../enums/BadgeColorEnum';
import { httpClient } from './helper/httpClient';

export interface ICreateBadgeParams {
  name: string;
  color: BadgeColorEnum;
}

export interface IUpdateBadgeParams {
  name?: string;
  color?: BadgeColorEnum;
}

class BadgeService {
  private _baseURL = 'badges';

  getAll(search?: string): Promise<IBadge[]> {
    const url =
      search && search.trim().length > 0
        ? `${this._baseURL}?search=${encodeURIComponent(search.trim())}`
        : this._baseURL;
    return httpClient.get<null, IBadge[]>(url);
  }

  create(data: ICreateBadgeParams): Promise<IBadge> {
    return httpClient.post<null, IBadge>(this._baseURL, { ...data });
  }

  update(id: string, data: IUpdateBadgeParams): Promise<void> {
    return httpClient.patch(`${this._baseURL}/${id}`, { ...data });
  }

  remove(id: string): Promise<void> {
    return httpClient.delete(`${this._baseURL}/${id}`);
  }

  attachToLead(leadId: string, badgeId: string): Promise<void> {
    return httpClient.post(`leads/${leadId}/badges/${badgeId}`);
  }

  detachFromLead(leadId: string, badgeId: string): Promise<void> {
    return httpClient.delete(`leads/${leadId}/badges/${badgeId}`);
  }
}

export default new BadgeService();
